// modules/land-for-sale/elements/PlanLotsContainer.js
import React        from 'react';
import PlanLotOutline  from './PlanLotOutline';

//const sources = require('../../config.json');

class PlanLotsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.renderLotHovers = this.renderLotHovers.bind(this);
    }

    renderLotHovers(element) {
        return (
            <div key={element.id} className="landforsale-map_lot_hover">
                <PlanLotOutline  width={this.props.width} height={this.props.height}
                                 element={element} messenger={this.props.messenger}/>
            </div>
        )
    }

    render() {
        return(
            <div className="landforsale-map_lots_container">
                {this.props.elements.map(this.renderLotHovers)}
            </div>
        )
    }
}
export default PlanLotsContainer;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanLotsContainer.js
 **/